<template>
  <el-select
    v-model="roleId"
    size="small"
    clearable
    filterable
    remote
    :remote-method="keyword => searchRole(keyword)"
    :placeholder="placeholder || $t('txt.targetRole')"
    @input="inputChange"
  >
    <el-option
      v-for="item in roleList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
      >
    </el-option>
  </el-select>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'targetUser',
  props: {
    value: [String, Number],
    status: {
      type: [Number, String],
      default: ''
    },
    placeholder: {
        type: String,
        default: ''
    },
    size: {
      type: [Number, String],
      default: ''
    }
  },
  data () {
    return {
      roleList: [],
      roleId: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions('role', ['findFilterRolesApi']),
    async init () {
      await this.searchRole()
      if (this.roleId) {
        const isEnable = this.roleList.map(v => v.id).includes(this.value)
        if (!isEnable) {
          this.roleId = undefined
          this.$emit('clearRole')
        }
      }
    },
    async searchRole (keyword) {
      const res = await this.findFilterRolesApi({ keyword, status: this.status, size: this.size })
      this.roleList = res
    },
    inputChange () {
      this.$emit('input', this.roleId)
    },
    setRoleList (list) {
      this.roleList = list || []
    }
  },
  watch: {
    value: {
      handler (v) {
        this.roleId = v
      },
      immediate: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/targetUsers/targetRole.vue